module.exports = __webpack_public_path__ + "static/cultish_home-cd7c9d5688ba6689b086839bcab8c342.jpg";